import Checkbox from '@material-ui/core/Checkbox'
import TablePagination from '@material-ui/core/TablePagination'
import MaterialTable from 'material-table'
import React from 'react'
import { withRouter } from 'react-router-dom'
import { DeleteChapter } from './Delete'

const pageTitle = 'Chapters'
const columns = [
  { title: 'Title', field: 'title' },
  { title: 'Slug', field: 'slug' },
  { title: 'Free', field: 'isFree', type: 'boolean' },
  {
    title: 'Order',
    sorting: false,
    render: (rowData) => rowData.tableData.id + 1,
  },
  {
    title: 'Published',
    field: 'state',
    type: 'boolean',
    render: (rowData) => (
      <Checkbox checked={rowData.state === 'published'} disabled />
    ),
  },
]
const options = {
  sorting: true,
  columnsButton: true,
  exportButton: true,
  // filtering: true,
  emptyRowsWhenPaging: false,
  pageSize: 10,
  actionsColumnIndex: -1,
}

// The pagination component is not right with rtl
const components = {
  Pagination: (props) => (
    <TablePagination {...props} style={{ direction: 'ltr' }} />
  ),
}

class ChapterTable extends React.Component {
  state: any = {
    deleteChapter: null,
  }

  props: any

  actions = [
    (rowData) => ({
      icon: 'arrow_upward',
      tooltip: 'Move up',
      disabled: rowData.tableData.id === 0,
      onClick: (e, row) => {
        this.handleUp(e, row)
      },
    }),
    (rowData) => ({
      icon: 'arrow_downward',
      tooltip: 'Move down',
      disabled: rowData.tableData.id === this.props.data.length - 1,
      onClick: (e, row) => {
        this.handleDown(e, row)
      },
    }),
    {
      icon: 'edit',
      tooltip: 'Edit chapter',
      onClick: (e, row) => {
        this.handleEdit(e, row)
      },
    },
    {
      icon: 'delete',
      tooltip: 'Delete chapter',
      onClick: (e, row) => {
        this.handleDelete(e, row)
      },
    },
  ]

  handleEdit = (e, rowData) => {
    const { history } = this.props
    history.push(`/chapters/${rowData.slug}`)
  }

  handleDelete = (e, rowData) => {
    this.openDelete(rowData)
  }

  handleAfterDelete = () => {
    const { onDelete } = this.props
    this.closeDelete()
    if (onDelete) onDelete()
  }

  handleUp = (e, rowData) => {
    const { onUp } = this.props
    if (onUp) onUp(rowData)
  }

  handleDown = (e, rowData) => {
    const { onDown } = this.props
    if (onDown) onDown(rowData)
  }

  openDelete = (rowData) => {
    this.setState({ deleteChapter: rowData })
  }

  closeDelete = () => {
    this.setState({ deleteChapter: null })
  }

  render() {
    const { deleteChapter } = this.state
    const { data } = this.props
    return (
      <React.Fragment>
        <MaterialTable
          // @ts-expect-error legacy
          columns={columns}
          data={data}
          title={pageTitle}
          options={options}
          components={components}
          actions={this.actions}
        />
        <DeleteChapter
          chapter={deleteChapter}
          forceOpen={!!deleteChapter}
          onClose={this.closeDelete}
          onAfterDelete={this.handleAfterDelete}
        />
      </React.Fragment>
    )
  }
}

export default withRouter(ChapterTable)
